import { Component } from '@angular/core';

@Component({
    selector: 'nio-migration-large-texas-city-draas',
    templateUrl: './migration-large-texas-city-draas.component.html',
    styleUrls: ['./migration-large-texas-city-draas.component.scss'],
    standalone: false
})
export class MigrationLargeTexasCityDraasComponent {}
